import { api } from 'data/api/api'

import { DeleteFeedbackArgs } from '../types/feedback'

export const deleteFeedback = ({ feedbackId }: DeleteFeedbackArgs) =>
  api.delete(`/user_feedbacks/${feedbackId}`)
